import * as types from './types';

const initialState = {
  modalData: {
    open: false,
    variant: 'primary',
    title: '',
    body: '',
    itemData: {},
  },
  editableItem: {},
  categories: [],
  categoriesLoading: true,
  currentRestaurant: null,
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_MODAL_DATA:
      return {
        ...state,
        modalData: {
          ...state.modalData,
          ...action.payload,
        },
      };
    case types.SET_CURRENT_RESTAURANT:
      return {
        ...state,
        currentRestaurant: action.payload,
      };
    case types.SET_EDITABLE_ITEM:
      return {
        ...state,
        editableItem: action.payload,
      };
    case types.GET_CATEGORIES_REQUEST:
      return {
        ...state,
        categoriesLoading: true,
      };
    case types.GET_CATEGORIES_FAILURE:
      return {
        ...state,
        categoriesLoading: false,
      };
    case types.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
        categoriesLoading: false,
      };
    default:
      return state;
  }
};

export default commonReducer;
